import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDownFocusedIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.3392 7.5536C4.09266 7.30706 3.69294 7.30706 3.4464 7.5536C3.19986 7.80014 3.19986 8.19986 3.4464 8.4464L7.29289 12.2929C7.68342 12.6834 8.31658 12.6834 8.70711 12.2929L12.5536 8.4464C12.8001 8.19986 12.8001 7.80014 12.5536 7.5536C12.3071 7.30706 11.9073 7.30706 11.6608 7.5536L8.70711 10.5073C8.31658 10.8978 7.68342 10.8978 7.29289 10.5073L4.3392 7.5536Z",
		fill: "#1377E7"
	})
});
export default SvgArrowDownFocusedIcon;
